// extracted by mini-css-extract-plugin
export default {"desktop":"o8Gcl_","compact":"OTiTim","mobile":"FtLty_","mobileFontSize":"JS6qc3","upgrade":"DCT1rm"};